export const environment = {
  environmentName: 'dev',
  production: true,

  backend: {
    baseUrl: 'https://niclen-app-tm-dev-dewest.azurewebsites.net',
    apiUrl: '/api/',
  },
  azureActiveDirectory: {
    authorityDomain: 'login.microsoftonline.com',
    clientId: '62aa9b0d-7f26-4996-9201-f2f536ddc7f8',
    scopes: ['api://1410ca6b-b75d-4558-8876-51d0e8bda747/niclen.access'],
    authorities: {
      signUpSignIn: 'https://login.microsoftonline.com/niclen.de',
      acquireToken: 'https://login.microsoftonline.com/niclen.de',
    },
  },
  appInsights: {
    instrumentationKey: '',
  },
};
